import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replace'
})
export class ReplacePipe implements PipeTransform {

    public transform(value: string, regexValue: string, replaceValue: string): string {
        let regex: RegExp = new RegExp(regexValue, 'g');

        return value?.replace(regex, replaceValue);
    }
}